module.exports = __webpack_public_path__ + "static/img/pic-bg-active-2.5c60b13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/pic-bg-active-2.png
// module id = HRfu
// module chunks = 0